<template>
  <div class="fit-bounds-control">
    <b-button @click="fitAll" size="sm" variant="secondary" v-translate>Fit map</b-button>
  </div>
</template>

<script>
import MapService from '@/services/MapService'

export default {
  name: 'FitBoundsControl',
  methods: {
    fitAll() {
      MapService.fitAll()
    }
  }
}
</script>

